import { SxProps, Theme } from '@mui/material';
import { Control, Controller } from 'react-hook-form';

import { NumberField } from './number-field';

interface NumberFieldFormElementProps {
  name: string;
  label?: string;
  min?: number;
  max?: number;
  endAdornment?: React.ReactNode;
  mode?: 'onChange' | 'onChangeCommitted';
  sx?: SxProps<Theme>;
  control?: Control<Record<string, number>>;
  disabled?: boolean;
  showSpinners?: boolean;
  size?: 'small' | 'medium';
}

export const NumberFieldFormElement = ({
  name,
  label,
  min,
  max,
  endAdornment,
  mode = 'onChangeCommitted',
  sx,
  control,
  disabled,
  showSpinners = true,
  size,
}: NumberFieldFormElementProps) => {
  return (
    <Controller
      control={control}
      render={({ field: { onChange, ...other }, fieldState: { error } }) => {
        return (
          <NumberField
            {...other}
            onValueChange={mode === 'onChange' ? onChange : undefined}
            onValueCommitted={mode === 'onChangeCommitted' ? onChange : undefined}
            min={min}
            max={max}
            label={label}
            sx={sx}
            size={size}
            endAdornment={endAdornment}
            error={!!error}
            helperText={error?.message}
            disabled={disabled}
            showSpinners={showSpinners}
          />
        );
      }}
      name={name}
    />
  );
};
